import { isAuthenticatedCustomer } from '@ori/auth';
import { validateStatus } from '@ori/fetching';
import { useGetTenantApplicationsWebMessengerConfiguration } from '@ori/static-api-client-react';

import { useWebMessengerRequestParams } from './useWebMessengerRequestParams';
import { useConfiguration } from '../contexts';

export const useGetWebMessengerConfiguration = () => {
  const { tenant, customerId } = useConfiguration();
  const { customerTypeId, relativeUrl, visitorSegment } = useWebMessengerRequestParams();
  const isAuthenticated = isAuthenticatedCustomer(customerId);

  return useGetTenantApplicationsWebMessengerConfiguration(
    tenant,
    {
      customerTypeId,
      relativeUrl,
      visitorSegment,
    },
    {
      swr: {
        enabled: !isAuthenticated || (customerTypeId !== undefined && visitorSegment !== undefined),
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
      },
      request: {
        validateStatus,
      },
    },
  );
};
